import { retrieveMatterEventsV3 } from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static/query-keys";
import { infiniteQueryOptions } from "@tanstack/react-query";

export const retrieveMatterEventsQueryOptions = (
  data: Parameters<typeof retrieveMatterEventsV3>[0],
) => ({
  queryKey: [
    queryKeys.matters,
    data.matterId,
    "events-v3",
    data.pageNumber ?? 1,
    data.pageSize ?? 1000,
    data,
  ],
  enabled: Boolean(data.matterId),
  queryFn: () => retrieveMatterEventsV3(data),
});

export const retrieveMatterEventsInfiniteQueryOptions = (
  data: Omit<Parameters<typeof retrieveMatterEventsV3>[0], "pageNumber">,
) => {
  const params = { ...data, pageSize: data.pageSize ?? 50 };

  return infiniteQueryOptions({
    queryKey: [
      queryKeys.matters,
      data.matterId,
      "events-v3",
      "infinite",
      params,
    ],
    enabled: Boolean(data.matterId),
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      retrieveMatterEventsV3({ ...params, pageNumber: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const pageNumber = lastPage.pagination?.pageNumber ?? allPages.length;
      const pageSize = lastPage.pagination?.pageSize ?? params.pageSize;
      const count = lastPage.pagination?.count ?? 0;
      return pageNumber * pageSize < count ? pageNumber + 1 : undefined;
    },
  });
};
